export const bscId =process.env.REACT_APP_CHAIN_ID
export const ethId =process.env.REACT_APP_ETH_CHAIN_ID